import React, { Component, Fragment } from 'react'
import Link from "next/link"
import Newsletter from "./theme/components/Newsletter";
import { applyLang } from "../../i18n";
import PreviewArticle from "./Preview/PreviewArticle";
import { Divider } from "antd";
import { t } from "@lingui/core/macro"
import { Trans } from "@lingui/react/macro"
import { fetchEvents } from "../../services/EventService";

export default class Footer extends Component {

    state = {
        usefulLinks: [],
        events: [],
        eventGroupes: [],
        loading: true
    }

    componentDidMount() {
        const context = this.props.context
        const { org, config } = context

        const build = () => {
            if (config["footer.usefullinks.disable"] !== true) {
                this.getUsefulLinks()
            }
        }

        if (org) {
            fetchEvents(org.id, {virtualId: org.virtualId || null}).then(d => {
                this.setState({ events: d.events, eventGroupes: d.eventGroupes, loading: false }, build)
            })
        } else {
            this.setState({ loading: false }, build)
        }
    }

    async getUsefulLinks() {
        const context = this.props.context
        // Événements issus de /v1/events (fetch client), plus de org.events.
        const { org, config } = context
        const events = this.state.events

        let links = []

        org.pages.filter(i => i.datetime).forEach(i => {
            i = applyLang(i, context.lang)
            const datetime = i.editDatetime ? new Date(i.editDatetime) : new Date(i.datetime)
            links.push({
                id: i.id,
                label: i.title,
                link: org.BASE_WEB_URL + "/" + i.route.join("/"),
                datetime: datetime
            })
        })

        org.forms.filter(i => i.active).forEach(i => {
            i = applyLang(i, context.lang)
            links.push({
                id: i.id,
                label: i.title,
                link: org.BASE_WEB_URL + "/form/" + i.id,
                datetime: new Date(i.datetime)
            })
        })

        ;(events || []).forEach(i => {
            i = applyLang(i, context.lang)
            links.push({
                id: i.id,
                label: i.name,
                link: org.BASE_WEB_URL + "/evenement/" + i.id,
                datetime: new Date(i.dateEvent)
            })
        })

        org.caisses.filter(i => i.active && !i.paused && !i.hidden).forEach(i => {
            i = applyLang(i, context.lang)
            links.push({
                id: i.id,
                label: i.name,
                link: org.BASE_WEB_URL + "/don/" + i.id,
                datetime: new Date(i.datetime)
            })
        })

        links.sort((a, b) => {
            if (a.datetime === b.datetime) {
                return 0
            }
            return a.datetime < b.datetime ? 1 : -1
        })

        this.setState({ usefulLinks: links })
    }

    render() {
        const mini = this.props.mini
        const context = this.props.context
        const { org, config } = context

        if (context.render === "embed") {
            return null
        }

        let usefulLinks = []
        if (!org.limited) {
            //usefulLinks=this.state.usefulLinks
        }

        return (
            <Fragment>
                {!org.limited && !mini && config["home.sections.disable.auto_content"] !== true && <PreviewArticle context={context} />}

                <div className={`wpo-ne-footer ${this.props.footerClass}`}>
                    {!org.limited && !mini && <Newsletter context={context} />}

                    <footer className="wpo-site-footer">
                        <div className="wpo-upper-footer">
                            <div className="container">
                                <div className="row">
                                    <div className="col col-lg-3 col-md-6 col-12 d-flex flex-column align-items-center">
                                        <div className="widget about-widget">
                                            <div className="logo widget-title ">
                                                <img src={org.logo} alt="" />
                                            </div>
                                            <p style={{ marginTop: 10, textAlign: "center" }}>{org.name}</p>
                                            <ul>
                                                {config["social.whatsapp"] && (
                                                    <li><a href={config["social.whatsapp"]}><img src={"/icons/whatsapp.png"} style={{ width: 20, }} /></a></li>
                                                )}

                                                {config["social.yt"] && (
                                                    <li><a href={config["social.yt"]}><img src={"/icons/youtube.png"} style={{ width: 20, marginTop: 3 }} /></a></li>
                                                )}

                                                {config["social.fb"] && (
                                                    <li><a href={config["social.fb"]}><img src={"/icons/facebook.png"} style={{ width: 20, }} /></a></li>
                                                )}

                                                {config["social.insta"] && (
                                                    <li><a href={config["social.insta"]}><img src={"/icons/instagram.png"} style={{ width: 18, }} /></a></li>
                                                )}

                                                {config["social.tiktok"] && (
                                                    <li><a href={config["social.tiktok"]}><img src={"/icons/tiktok.png"} style={{ width: 18, }} /></a></li>
                                                )}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col col-lg-3 col-md-3 col-12">
                                        <div className="widget link-widget">
                                            <div className="widget-title">
                                                <h3>{usefulLinks.length > 0 && <Trans>Liens Utiles</Trans>}</h3>
                                            </div>
                                            <ul>
                                                {usefulLinks.slice(0, 6).map(item => (
                                                    <li><Link href={item.link}>{item.label}</Link></li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col col-lg-2 col-md-6 col-12">
                                        <div className="widget link-widget">
                                            <div className="widget-title">
                                                <h3> </h3>
                                            </div>
                                            <ul>
                                                <li><a href={"https://kehila.io/export-cerfas"}>{t`Mes Reçus Fiscaux`}</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col col-lg-3 offset-lg-1 col-md-6 col-12">
                                        <div className="widget market-widget wpo-service-link-widget">
                                            <div className="widget-title">
                                                <h3><Trans>Contact</Trans></h3>
                                            </div>
                                            <div className="contact-ft">
                                                <ul>
                                                    <li><i className="fi fi-rr-user"></i>{org.contact.prenom} {org.contact.nom}</li>
                                                    <li><i className="fi ti-location-pin"></i>{org.adresse}, {org.postal}, {org.ville}</li>
                                                    <li><i className="fi flaticon-call"></i><a style={{ color: "#666" }} href={"tel:" + org.contact.tel}> {org.contact.tel}</a></li>
                                                    <li><i className="fi flaticon-envelope"></i><a style={{ color: "#666" }} href={"mailto:" + org.contact.email}> {org.contact.email}</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wpo-lower-footer">
                            <div className="container">
                                <div className="row">
                                    <div className="col col-xs-12">
                                        <div style={{ display: "flex", flexDirection: "column", color: "#444444", textDecoration: "none" }}>
                                            <p style={{fontStyle:"italic"}}><a href={"https://unisoft.world"} target={"_blank"}><Trans>Propulsé par</Trans> <span style={{textDecoration:"underline"}}>Unisoft.world</span></a></p>
                                            <p><a href={"/docs/CGU.pdf"} target={"_blank"}>{t`Conditions générales d'utilisation`}</a></p>
                                            <p><a href={"/docs/Politique-de-Confidentialité.pdf"} target={"_blank"}>{t`Politique de Confidentialité`}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </footer>
                </div>
            </Fragment>
        )
    }
}
